import { render, staticRenderFns } from "./ledger-balance.vue?vue&type=template&id=0a0e0b7d&"
import script from "./ledger-balance.vue?vue&type=script&lang=js&"
export * from "./ledger-balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports